import React from 'react';
import BaseIcon from './BaseIcon';

import { ReactComponent as IconPath } from 'assets/images/icons/info-icon.svg';

function InfoIcon(props) {
  return <BaseIcon SVGElement={IconPath} {...props} />;
}

export default InfoIcon;
